import { connect } from 'react-redux';
import FoundationFieldView from './foundation_field_view';

const mapStateToProps = () => ({
});

const FoundationFieldContainer = connect(mapStateToProps)(FoundationFieldView);

export default FoundationFieldContainer;
